<template>
  <el-dialog :visible.sync="visible" :title="title" :close-on-click-modal="false"
             :close-on-press-escape="false" width="80%">
    <SweetTable ref="table" url="/erp/settle/material/material/use/list" :query-form="queryForm" :summaries-column="['receivedCount','totalUseCount']" :before-table-binding="beforeTableBinding" :auto-load="false"
                :is-page="false">
      <el-table-column
          prop="companyName"
          label="工厂名称"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.code"
          label="品番号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.skuCode"
          label="SKU"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.name"
          label="品名"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.color"
          label="颜色"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.size"
          label="规格"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="receivedCount"
          label="生产数量"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="bomRealCount"
          label="实际单耗"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="totalUseCount"
          label="用料数"
          header-align="center"
          align="center"
      ></el-table-column>
    </SweetTable>
  </el-dialog>
</template>

<script>
import SweetTable from '@/mixins/SweetTable'
import BigNumber from 'bignumber.js'

export default {
  name: 'material-use-list',
  mixins: [SweetTable],
  data () {
    return {
      visible: false,
      materialInfo:{},
      queryForm: {
        factoryId: null,
        materialId: null,
        orderId: null,
      }
    }
  },
  computed:{
    title(){
      let tmp=[this.materialInfo.name,this.materialInfo.color,this.materialInfo.size,this.materialInfo.attr1,this.materialInfo.attr2]
      return '物料使用清单【'+tmp.join(' ')+'】'
    }
  },
  methods: {
    beforeTableBinding(dataList){
      dataList.forEach(row=>{
     row.totalUseCount=new BigNumber(row.receivedCount).multipliedBy(row.bomRealCount).toFixed(4)
      })
    },
    init (factoryId, materialId, orderId) {
      this.queryForm = {
        factoryId: factoryId,
        materialId: materialId,
        orderId: orderId
      }
      this.reload()
      this.visible = true
    }
  }
}
</script>

<style scoped>

</style>
